"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Schema_1 = require("../../Schema");

var Collection_1 = __importDefault(require("./Collection"));

var RpcSchema = /*#__PURE__*/function () {
  function RpcSchema(api, collection, name, data) {
    var cache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    _classCallCheck(this, RpcSchema);

    this.api = api;
    this.collection = collection;
    this.name = name;
    this._data = new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 4;
                  break;
                }

                resolve(data);
                _context.next = 15;
                break;

              case 4:
                _context.prev = 4;
                _context.t0 = resolve;
                _context.next = 8;
                return api.queue.fetchSchema(collection, name, cache);

              case 8:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t2 = _context["catch"](4);
                reject(_context.t2);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this._collection = new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  resolve(new Collection_1.default(api, collection, undefined, cache));
                } catch (e) {
                  reject(e);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
  }

  _createClass(RpcSchema, [{
    key: "format",
    value: function () {
      var _format = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = Schema_1;
                _context3.next = 3;
                return this._data;

              case 3:
                _context3.t1 = _context3.sent.format;
                return _context3.abrupt("return", _context3.t0.ObjectSchema.call(_context3.t0, _context3.t1));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function format() {
        return _format.apply(this, arguments);
      }

      return format;
    }()
  }, {
    key: "rawFormat",
    value: function () {
      var _rawFormat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._data;

              case 2:
                return _context4.abrupt("return", _context4.sent.format);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function rawFormat() {
        return _rawFormat.apply(this, arguments);
      }

      return rawFormat;
    }()
  }, {
    key: "toObject",
    value: function () {
      var _toObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = this.collection;
                _context5.t1 = this.name;
                _context5.next = 4;
                return this.rawFormat();

              case 4:
                _context5.t2 = _context5.sent;
                return _context5.abrupt("return", {
                  collection_name: _context5.t0,
                  schema_name: _context5.t1,
                  format: _context5.t2
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function toObject() {
        return _toObject.apply(this, arguments);
      }

      return toObject;
    }()
  }]);

  return RpcSchema;
}();

exports.default = RpcSchema;